import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaLinkedin } from "react-icons/fa";

export default function Contact() {
  return (
    <section className="py-5 bg-white text-center">
      <div className="container" fluid>
        <h2 className="text-primary fw-bold display-6">Contact Us</h2>
        <div className="mt-4">
          <p className="d-flex align-items-center justify-content-center text-secondary">
            <FaPhone className="me-2 text-primary" /> +91 70363 30011
          </p>
          <p className="d-flex align-items-center justify-content-center text-secondary mt-2">
            <FaEnvelope className="me-2 text-primary" /> blueberryinfratechpvtltd@gmail.com
          </p>
          <p className="d-flex align-items-center justify-content-center text-secondary mt-2">
            <FaMapMarkerAlt className="me-2 text-primary" /> Hyderabad, India
          </p>
        </div>
        <div className="mt-4 d-flex justify-content-center gap-3">
          <a /*href="https://www.facebook.com"*/ target="_blank" rel="noopener noreferrer">
            <FaFacebook className="text-primary fs-3 cursor-pointer" />
          </a>
          <a /*href="https://www.linkedin.com"*/ target="_blank" rel="noopener noreferrer">
            <FaLinkedin className="text-primary fs-3 cursor-pointer" />
          </a>
        </div>
      </div>
    </section>
  );
}
